import { authClient, API } from "../index";

export const getRelojes = ({ propio, page, limit, filters }) => {
  if (propio) {
    return authClient().get(`${API}/reloj/?propio=true`);
  } else {
    return authClient().get(`${API}/reloj/`, {
      params: { page, limit, ...filters },
    });
  }
};

export const getRelojById = (id) => {
  return authClient().get(`${API}/reloj/${id}`);
};
export const postReloj = (reloj) => {
  return authClient().post(`${API}/reloj/`, reloj);
};
export const updateReloj = (id, reloj) => {
  return authClient().put(`${API}/reloj/${id}`, reloj);
};
export const deleteReloj = (id) => {
  return authClient().delete(`${API}/reloj/${id}`);
};
export const getTasarReloj = (obj) => {
  return authClient().post(`${API}/reloj/tasar`, { ...obj, skipLog: true });
};

// Buscar relojes para tasación (igual que en la web: Chrono24 + manual)
export const searchWatchesForTasacion = (searchTerm, page = 1, limit = 50) => {
  const params = {
    page,
    limit,
    showAll: true,
    origin: "tasacion",
    sort: "name-asc",
  };
  if (searchTerm && String(searchTerm).trim()) {
    params.q = String(searchTerm).trim();
  }
  return authClient().get(`${API}/reloj`, { params });
};
// Change status reloj
export const changeStatusReloj = async (id, active) => {
  return authClient().put(`${API}/reloj/change-status/${id}`, { active });
};

// Change stock reloj
export const changeStockReloj = async (id, stock) => {
  return authClient().put(`${API}/reloj/change-stock/${id}`, { stock });
};

// Change desta reloj
export const changeDestaReloj = async (id, destacado) => {
  return authClient().put(`${API}/reloj/change-feature/${id}`, { destacado });
};

// Change novedad reloj
export const changeNovedadReloj = async (id, novedad) => {
  return authClient().put(`${API}/reloj/change-novedad/${id}`, { novedad });
};

export const changBannerReloj = async (id, banner) => {
  return authClient().put(`${API}/reloj/change-banner/${id}`, { banner });
};

export const importManualRelojes = (csvData) => {
  return authClient().post(`${API}/reloj/import-manual`, { csvData });
};

export const deleteManualRelojes = () => {
  return authClient().delete(`${API}/reloj/delete-manual`);
};

// Reset statistics (views and likes) for all relojes
export const resetRelojesStats = () => {
  return authClient().post(`${API}/reloj/reset-stats`);
};

// Get all bestsellers
export const getBestsellers = () => {
  return authClient().get(`${API}/reloj/bestsellers/list`);
};

// Update bestseller status and position
export const updateBestseller = (id, data) => {
  return authClient().put(`${API}/reloj/change-bestseller/${id}`, data);
};